/** Full-rate PPG batch: 500 Hz × 60 s = 30000 samples */
export const PPG_FULL_BATCH_SAMPLES = 30000;

/** Half-rate PPG batch: 250 Hz × 60 s = 15000 samples */
export const PPG_HALF_BATCH_SAMPLES = 15000;

/** Sample interval at 500 Hz */
export const PPG_DT_500HZ = 0.002;

/** Sample interval at 250 Hz */
export const PPG_DT_250HZ = 0.004;

/** Duration of each half of the live sliding window (seconds) */
export const PPG_WINDOW_SECONDS = 7.08;

/**
 * Infer PPG sample interval from batch size or max sample index.
 * Batches with ≤15000 samples are treated as 250 Hz (0.004 s); otherwise 500 Hz (0.002 s).
 */
export function getPpgSampleInterval(sampleCount: number, maxSampleIndex?: number): number {
  const effectiveCount = Math.max(
    sampleCount,
    maxSampleIndex != null ? maxSampleIndex + 1 : 0
  );
  if (effectiveCount > 0 && effectiveCount <= PPG_HALF_BATCH_SAMPLES) {
    return PPG_DT_250HZ;
  }
  return PPG_DT_500HZ;
}

/** Number of samples that fit in one half-window at the given interval. */
export function getPpgWindowSampleCount(dt: number = PPG_DT_500HZ): number {
  return Math.floor(PPG_WINDOW_SECONDS / dt);
}
